import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const list = async (params: object) => {
  return await GET({ url: Api.list, params, showError: false })
}
